export const PROVIEW_URL_V7_PLUS = 'https://cdn.proview.io/client/init.js';
export const PROVIEW_V8_SDK_URL = 'https://sdk.tlv.cx/session/init.js';
const PROVIEW_SCRIPT_ELEMENT_ID = 'proview-script-tag';
export const cleanupProviewDOMElements = (proviewUrl) => {
    // remove known Proview-related DOM nodes
    const elementsToRemove = [
        'proctor_container',
        'tvp_screen_share_container',
        'proctor_flash_container',
        'screen_capture',
        'backdrop_element',
    ];
    elementsToRemove.forEach((id) => {
        const element = document.getElementById(id);
        if (element)
            element.remove();
    });
    // remove the specific script element
    const scriptElements = document.querySelectorAll(`script[src="${proviewUrl}"]`);
    scriptElements.forEach((script) => {
        script.parentNode?.removeChild(script);
    });
    // remove pre-initialized script tag
    const preScript = document.getElementById(PROVIEW_SCRIPT_ELEMENT_ID);
    if (preScript)
        preScript.remove();
};
// Tears down every trace of a completed Proview session — the SDK globals (both the v8
// `window.Proview` object and the legacy v7 `window.tv`/`TalviewProctor` client), plus their
// DOM containers and script tags. Reusing `window.Proview` across attempts replays its
// internal "session completed" state instead of starting a new session (CX-5829), so this
// must run to completion BEFORE anything calls startProview()/startV8Proview() again — callers
// should invoke it synchronously ahead of any dispatch that could re-arm ProView (e.g.
// setShouldStartProview), rather than relying on React effect ordering to reset it in time.
export const resetProviewSDKState = () => {
    if (window.Proview) {
        delete window.Proview;
    }
    if (window.tv) {
        delete window.tv;
    }
    if (window.TalviewProctor) {
        delete window.TalviewProctor;
    }
    cleanupProviewDOMElements(PROVIEW_URL_V7_PLUS);
    cleanupProviewDOMElements(PROVIEW_V8_SDK_URL);
};
